import * as actions from "./actions";
import { initScore } from "../../config/games";

export const setAuth = (auth) => {
  return {
    type: actions.GAME_AUTH,
    isAuth: auth,
  };
};

export const setTheme = (theme) => {
  return {
    type: actions.SET_THEME,
    theme,
  };
};


export const startGame = (options) => {
  const playerBank = [
    {
      name: "Player 1",
      color: "blue",
    },
    {
      name: "Player 2",
      color: "orange",
    },
    {
      name: "Player 3",
      color: "green",
    },
    {
      name: "Player 4",
      color: "red",
    },
  ];

  let players = [];
  const currentScore = initScore(options.gameType);
  for (let id = 0; id < parseInt(options.players); id++) {

    const newPlayer = {
      ...playerBank[id],
      id,
      currentScore,
      points: 0,
      darts: 0,
      ppd: 0,
      history: [],
      cricket: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        17: 0,
        18: 0,
        19: 0,
        20: 0,
        25: 0,
      },
    };

    players.push(newPlayer);
  }

  return {
    theme: options.theme,
    type: actions.GAME_START,
    players: players,
    gameType: options.gameType,
    currentRound: {
      player: 0,
      ...players[0],
      scores: [],
      darts: 0,
    },
    lastRound: {
      player: null,
      scores: [],
      total: 0,
      darts: 0,
    },
  };
};

export const resetGame = (players, winningPlayer) => {
  return {
    type: actions.GAME_RESET,
  };
};

export const endGame = (players, winningPlayer, roundCount) => {
  return {
    isEndGame: true,
    type: actions.GAME_END,
    players,
    winner: winningPlayer,
    roundCount,
  };
};
